import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loginUser } from "../../reducers/authSlice";

import { Container, TextField, Box, Button, InputAdornment, IconButton, Grid, Typography, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles'

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Login() {

  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const err = useSelector((state) => state.auth.errors);

  const theme = useTheme();
  const image = theme.palette.mode === 'dark' ? './juvalfri/logo_v.svg' : './juvalfri/logo_v-light.svg'

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({ email: '', password: '', emailnotfound: '', passwordincorrect: '' });
  const [showPassword, setShowPassword] = useState(false);
  let navigate = useNavigate();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
    document.getElementById('password').type = 'text';
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }

  }, [isAuthenticated])

  useEffect(() => {
    if (err) {
      setErrors(err);
    }
  }, [err])

  const handleSubmit = e => {
    e.preventDefault();

    const userData = {
      email: email,
      password: password
    };

    dispatch(loginUser(userData));
  };

  return (
    <Container maxWidth="xl" style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <Container>
        <Box mb={3}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button type='submit' variant="outlined" color={"secondary"}><i className="fad fa-long-arrow-left"></i>&nbsp; Regresar</Button>
          </Link>
        </Box>
      </Container>
      <Paper sx={{ maxWidth: '650px', py: 5, px: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'  }}>
        <Container style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Box mb={3}>
            <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "1.8em" }} >Iniciar Sesión</Typography>
          </Box>
        </Container>
        <img src={image} alt='cronos-logo' style={{ width: "20%" }} className='mb-4'></img>
        <br />
        <br />
        <Container style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Grid container maxWidth="sm" spacing={{ xs: 2, md: 3 }}>
              <Grid item display="grid" xs={12} >
                <TextField
                  error={errors.email ? true : false || errors.emailnotfound ? true : false}
                  variant="outlined"
                  id="email"
                  type={'email'}
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  label="Correo electrónico"
                  helperText={`${errors.email === undefined ? '' : errors.email}` || `${errors.emailnotfound === undefined ? '' : errors.emailnotfound}`}
                />
              </Grid>
              <Grid item display="grid" xs={12}>
                <TextField
                  error={errors.password ? true : false || errors.passwordincorrect ? true : false}
                  id="password"
                  label="Contraseña"
                  type={'password'}
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  endadornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        color="secondary"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  helperText={`${errors.password === undefined ? '' : errors.password}` || `${errors.passwordincorrect === undefined ? '' : errors.passwordincorrect}`}
                />
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                <Button type='submit' size="large" variant="contained" color={"secondary"}>Iniciar sesión &nbsp; <i className="fad fa-sign-in"></i></Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Paper>
    </Container>
  )
}

export default Login